import { DatabaseModel, ModelJson } from './database-model';

/** Rating in range [0;4] (-1 means unanswered) */
export type Rating = -1 | 0 | 1 | 2 | 3 | 4;

export class ReviewResponse extends DatabaseModel {
    /** Key of the question that was responded to */
    key: string = '';
    /** The question responded to */
    label: string = '';
    /** Rating chosen */
    rating: Rating = -1;
    /** Comment labels mapped by comment key */
    comments: { [key: string]: string } = {};
    /** Custom (free text) comment */
    customComment: string = '';
    /** When the response was created */
    createdOn: number | any = null;

    constructor(key: string = '', json: ModelJson = null) {
        super();
        if(json) this.fromJson(json);
        if(key) this.key = key;
    }
    
    public fromJson(json: ModelJson): ReviewResponse {
        Object.assign(this, json);
        return this;
    }

    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}

interface UserResponses { [ userKey: string ]: { responses: { [questionKey: string ]: ReviewResponse }, isStatEventSent: boolean } }

export class Review extends DatabaseModel {
    /** Key corresponding to the tour that was reviewed */
    public key: string = '';
    /** Tour question responses mapped by userKey */
    public review: UserResponses = {};
    /** When the last response was added */
    updatedOn: number | any = null;
    /** Tour key the review is related to */
    tourKey: string = '';
    /** User key of the user that made the review */
    userKey: string = '';
    /** The version of the app on the time of review */
    appVersion: string = '';

    constructor(key: string = '', json: ModelJson = null) {
        super();
        if(json) this.fromJson(json);
        if(key) this.key = key;
    }

    public fromJson(json: ModelJson): Review {
        Object.assign(this, json);
        return this;
    }

    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }

}